import { render, staticRenderFns } from "./ViewTaskTemplateModal.vue?vue&type=template&id=4271d418&scoped=true&"
import script from "./ViewTaskTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./ViewTaskTemplateModal.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=4271d418&prod&scoped=true&lang=css&"
import style1 from "./ViewTaskTemplateModal.vue?vue&type=style&index=1&id=4271d418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4271d418",
  null
  
)

export default component.exports